import React from 'react';

import classNames from 'classnames';
import { useSelector } from 'react-redux';

import UIResource from '@/components/UIResource';
import UIResourceHtml from '@/components/UIResource/Html';
import { selectLookup } from '@/ducks/common/selectors';
import { selectSettings } from '@/ducks/common/settings';
import { selectCurrencyCode } from '@/ducks/filters/selectors';
import { selectIsSailingDataLoaded, selectSailingData } from '@/ducks/voyageInfo/sailing/selectors';
import { selectUpliftMinimumDays } from '@/features/uplift/selectors';
import { durationInDaysUntil } from '@/helpers/util/dateUtil';
import withSkeleton from '@/hocs/withSkeleton';
import { useAppSelector } from '@/store';

import ConfidenceModuleListSkeleton from './ConfidenceModuleListSkeleton';

import './ConfidenceModuleList.scss';

const ConfidenceModuleList = ({ isMobile }) => {
  const serverISOtime = useSelector((state) => selectLookup(state)?.serverISOtime);
  const daysLeftForDeposit = useSelector((state) => selectSettings(state)?.daysLeftForDeposit);
  const daysLeftForHold = useSelector((state) => selectSettings(state)?.daysLeftForHold);
  const sailingData = useAppSelector(selectSailingData);
  const currencyCode = useAppSelector(selectCurrencyCode);

  const upliftMinimumDays = useAppSelector(selectUpliftMinimumDays);
  const daysLeftForUplift = upliftMinimumDays?.[currencyCode];

  const { startDate } = sailingData;
  const differenceInDays = durationInDaysUntil(startDate, serverISOtime);

  const cssClasses = classNames({
    ConfidenceModule: true,
    isMobile: !isMobile,
  });

  return (
    <div className={cssClasses}>
      <h3 className="title">
        <UIResource id="Precheckout.NeedToKnow.heading" />
      </h3>
      <ul className="mainListWrapper">
        <li className="mainList first">
          <div className="circle__one">
            <div className="circle__two" />
          </div>
          <div className="description">
            <UIResource id="NeedToKnow.ValueProposition" />
          </div>
        </li>
        {differenceInDays > 2 && (
          <>
            <li className="mainList">
              <div className="circle__one">
                <div className="circle__two" />
              </div>
              <div className="description">
                <UIResource id="Precheckout.NeedToKnow.Modification" />
              </div>
            </li>
            <li className="mainList">
              <div className="circle__one">
                <div className="circle__two" />
              </div>
              <div className="description">
                <UIResourceHtml id="Precheckout.needToKnow.flexiblePolicies.richText" />
              </div>
            </li>
          </>
        )}
        {differenceInDays > daysLeftForHold && (
          <li className="mainList">
            <div className="circle__one">
              <div className="circle__two" />
            </div>
            <div className="description">
              <UIResource id="PreCheckout.NeedToKnow.24HR" />
            </div>
          </li>
        )}
        {differenceInDays > daysLeftForDeposit && (
          <li className="mainList">
            <div className="circle__one">
              <div className="circle__two" />
            </div>
            <div className="description">
              <UIResource id="PreCheckout.NeedToKnow.Deposit" />
            </div>
          </li>
        )}
        {daysLeftForUplift && differenceInDays >= daysLeftForUplift && (
          <li className="mainList">
            <div className="circle__one">
              <div className="circle__two" />
            </div>
            <div className="description">
              <UIResource id="PreCheckout.NeedToKnow.uplift" />
            </div>
          </li>
        )}
        <li className="mainList">
          <div className="circle__one">
            <div className="circle__two" />
          </div>
          <div className="description">
            <UIResource id="NeedToKnow.VoyageProtection" />
          </div>
        </li>
        <li className="mainList last">
          <div className="circle__one">
            <div className="circle__two" />
          </div>
          <div className="description">
            <UIResource id="Precheckout.NeedToKnow.CreditCards" />
          </div>
        </li>
      </ul>
    </div>
  );
};

export default withSkeleton(ConfidenceModuleList, {
  selector: (state, { searchParams }) => selectIsSailingDataLoaded(state, searchParams),
  skeleton: ConfidenceModuleListSkeleton,
});
